<div class="main-section">
    <h3>Upload Income Proof</h3>
    <div class="proof-card">
        <div class="row">
            <div class="col-6">
                <div class="img-card">
                    <img class="placeholder-image"
                        src="https://images.5paisa.com/SPOT/activation/modification/mobile-screenshot.png" />
                    <span>Income Proof (1)</span>
                    <input type="file" class="file-input" [accept]="accept" [hidden]="true" (change)="uploadBankStatement($event,'upload1')"
                        #fileUpload1>
                    <img class="edit-icon" src="https://images.5paisa.com/SPOT/activation/modification/edit.svg"
                        (click)="fileUpload1.click()" />
                    <img class="check-icon"
                        src="https://images.5paisa.com/SPOT/activation/modification/checkCircle.svg" />
                </div>
                <span>{{fileName}}</span>
            </div>
            <div class="col-6" *ngIf="upload2Data != null || upload2Data != undefined">
                <div class="img-card">
                    <img class="placeholder-image"
                        src="https://images.5paisa.com/SPOT/activation/modification/mobile-screenshot.png" />
                    <span>Income Proof (2)</span>
                <input type="file" class="file-input" [accept]="accept" [hidden]="true" (change)="uploadBankStatement($event,'upload2')"
                        #fileUpload2>
                    <img class="edit-icon" src="https://images.5paisa.com/SPOT/activation/modification/edit.svg"
                        (click)="fileUpload2.click()" />
                    <img class="check-icon"
                        src="https://images.5paisa.com/SPOT/activation/modification/checkCircle.svg" />
                </div>
            </div>
        </div>
    </div>
    <div class="form-wrapper" *ngIf="isEncryptedPdf">
        <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>ENTER DOCUMENT PASSWORD </mat-label>
            <input matInput placeholder="Enter Password" #password1 maxlength="100" (focus)="onFocus()"/>
        </mat-form-field>
        <mat-form-field appearance="fill" floatLabel="always" *ngIf="upload2Data != null || upload2Data != undefined">
            <mat-label>ENTER DOCUMENT PASSWORD ( PROOF 2 )</mat-label>
            <input matInput placeholder="Enter Password" #password2 maxlength="100" />
        </mat-form-field>
        <mat-error>
            <span class="error" *ngIf="errorShow">
                {{ErrorMsg}}
            </span>
        </mat-error>
    </div>
    <!-- <button type="submit" class="btn btn-primary" (click)="getUploadManually()">
        {{btnText}}
    </button> -->
    <div class="bottom-button-wrapper btn position-relative" *ngIf="!btnLoader">
        <button type="submit" class="btn btn-primary" (click)="submitBtn()">
            {{btnText}}
        </button>
    </div>
    <div class="bottom-button-wrapper btn" *ngIf="btnLoader">
        <button class="btn btn-primary">
            <span class="stage">
                <span class="dot-pulse"></span>
            </span>
        </button>
    </div>
</div>